import { Component, Injector, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mq_List } from '../mq_list/mq_list';
import { MSteps } from '../msteps/msteps';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-mj_badge',
  templateUrl: 'mj_badge.html',
})
export class Mj_Badge extends Util {
  pagine: any;
  user: any;
  mj: any;
  fasi: any;
  items: any = [];
  //itemExpandHeight = 150;
  itemExpandHeight = [];
  mqs: any = [];
  badgeList = [];
  refresh_dashboard: boolean = false;
  constructor(public navCtrl: NavController,public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.mj = this.navParams.get('mj');
    //console.log('---mj:',this.mj);

    this.refreshpage(this.mj);

  }

  refreshpage(mj) {
    this.GetRequest('badgeMJ', mj.id).then(data => {
      this.badgeList = data['BadgeList'];
    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })

  }
  back() {
    if (this.refresh_dashboard == false)
      this.navCtrl.pop({ animate: false });
    else
      this.go_root();
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
  reset_badge(item) {
    //console.log(item);
    this.translate.get(['badge.AZZERAPERCORSOCONFIRM', 'badge.AZZERARECONFIRM'],{nome:item.nome}).subscribe(v => {
      this.presentPopover(event, Confirm, v['badge.AZZERAPERCORSOCONFIRM']).then((data) => {
        //console.log(data);
        if (data == 'confirm') {
          this.presentPopover(event, Confirm, v['badge.AZZERARECONFIRM'], 'danger').then((data_) => {
            if (data_ == 'confirm') {
              this.PostRequest('resetMJ', item.id, {}, true, true).then(data_x => {
                this.refresh_dashboard = true;
                //console.log(data_x);
                this.svuota_cache_all_mj(item.id)
                item.arr_expand = false;
              }).catch((e) => {
                //this.navCtrl.push(Mj_Detail,{mj:m});
                console.error(e)
              })
            }
          });
        }
      });
    });

  }
  show_detail_badge(b) {
    this.presentPopover(event, DetailBadge, b).then((data_) => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/mj_badge/mj_badge.ts